import {
  getMeta,
  eventTrendTotal,
  eventTrendTag
} from '../../service'
import filter from 'js/filter'
import moment from 'moment'

const financing_common = {
  inject: ['login', 'handleShowVipPormpt', 'loginVipFlow'],
  data() {
    return {
      spinShow: true,
      spinShow2: true,
      years: [2011, moment().year()],
      moment_year: moment().year(),
      today: moment().format('YYYY年MM月DD日'),
      columns: [{
          title: '公司名称',
          width: 240,
          render: (h, params) => {
            return h('div', {
              class: {
                company: true
              }
            }, [
              h('div', {
                on: {
                  click: () => {
                    if (this.user_key) {
                      this.goEntityDetail(params.row.comp_uid, 0)
                    } else {
                      this.login()
                    }
                  }
                },
                class: {
                  logo_img: true
                }
              }, [
                h('img', {
                  attrs: {
                    src: filter.logo_show(params.row.logo_path)
                  }
                })
              ]),
              h('div', {
                class: {
                  company_name: true
                }
              }, [
                h('div', {
                  class: {
                    company_info: true
                  }
                }, [
                  h('p', [
                    h('a', {
                      on: {
                        click: () => {
                          if (this.user_key) {
                            this.goEntityDetail(params.row.comp_uid, 0)
                          } else {
                            this.login()
                          }
                        }
                      }
                    }, params.row.short_name)
                  ])
                ])
              ])
            ])
          }
        },
        // {
        //   title: '领域',
        //   width: 220,
        //   render: (h, params) => {
        //     if (params.row.tag_arr.length > 0) {
        //       let tag_arr = []
        //       params.row.tag_arr.map((a, index) => {
        //         tag_arr.push(h('span', filter.deal(a, 'dynview_tag')))
        //         if (index < params.row.tag_arr.length - 1) tag_arr.push(h('span', '、'))
        //       })
        //       return h('div', {
        //         class: {
        //           'dec-clamp': true
        //         }
        //       }, tag_arr)
        //     } else {
        //       return h('span', '--')
        //     }
        //   }
        // },
        {
          title: '简要介绍',
          width: 220,
          render: (h, params) => {
            return h('div', {
              class: {
                'dec-clamp': true
              }
            }, filter.empty(params.row.description))
          }
        },
        {
          title: '当前轮次',
          width: 100,
          render: (h, params) => {
            if (params.row.event_type == '1') {
              return h('span', '被并购')
            } else {
              return h('span', filter.deal(params.row.round_id, 'round'))
            }
          }
        },
        {
          title: '最新获投时间',
          width: 140,
          render: (h, params) => {
            return h('span', filter.timeTrans(params.row.event_time))
          }
        },
        {
          title: '融资额',
          width: 130,
          render: (h, params) => {
            return h('span', filter.amountPrecise(params.row.amount, params.row.unit_id, params.row.precise))
          }
        },
        {
          title: '合投方',
          minWidth: 150,
          render: (h, params) => {
            if (params.row.tzf.length > 0) {
              let tzf = []
              params.row.tzf.map((a, index) => {
                if (a.entity_type != '2') {
                  tzf.push(h('a', {
                    on: {
                      click: () => {
                        if (this.user_key) {
                          this.goEntityDetail(a.entity_uid, a.entity_type)
                        } else {
                          this.login()
                        }
                      }
                    }
                  }, a.tz_entity_name))
                } else {
                  tzf.push(h('span', a.tz_p_name))
                }
                if (index < params.row.tzf.length - 1) tzf.push(h('span', '、'))
              })
              return h('div', {
                class: {
                  'dec-clamp': true
                }
              }, tzf)
            } else {
              return h('span', '未透露')
            }
          }
        }
      ],
      total: 0,
      mychart: '', // 当前组件的图表
      visible: false, // 下载模态框是否显示
      imgbase: '', // 图片的64位编码
      round_ids_arr: [],
      is_destroyed: false,
      unit_list: [{
          id: "1",
          name: "人民币"
        },
        {
          id: "3",
          name: "美元"
        }
      ],
      active_unit: '3',
      curInt: '',
      legend_colors: ['rgba(250, 122, 80, 1)', '#1EA69B', '#80DEEA', '#FFCB6A', '#E96350'],
      page_modal: false,
      sort_id: 0,
      sort_list: [
        {id: 0, name: '获投时间倒序'},
        {id: 1, name: '获投时间正序'},
        {id: 2, name: '融资金额降序'},
        {id: 3, name: '融资金额升序'}
      ],
      rate_year: 1
    }
  },
  provide() {
    return {
      page_title: this.page_title,
      name: this.name
    }
  },
  computed: {
    theme_switch() {
      return this.$store.state.theme_switch
    },
    slier_axis() {
      let arr = []
      for (var i = 2011; i <= this.moment_year; i++) {
        arr.push(i)
      }
      return arr
    },
    time_axis() {
      let arr = []
      for (var i = this.years[0]; i <= this.years[1]; i++) {
        arr.push(i)
      }
      return arr
    },
    quarter_arr() {
      let arr = []
      for (var i = this.years[0]; i <= this.years[1]; i++) {
        arr = arr.concat(['Q1', 'Q2', 'Q3', 'Q4'])
      }
      return arr
    },
    user_key() {
      return this.$store.state.user_key
    },
    user() {
      return this.$store.state.user
    },
    is_vip() {
      let user_info
      if (this.user && typeof this.user == 'string') {
        user_info = JSON.parse(this.user)
        return user_info.db_vip == '1' || user_info.vip == '1'
      } else if (this.user && typeof this.user == 'object') {
        return this.user.db_vip == '1' || this.user.vip == '1'
      } else {
        return false
      }
    }
  },
  methods: {
    /**
     * 按需获取元数据
     */
    async getMeta() {
      let res = await getMeta({
        name: ['round_ids_arr']
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'round_ids_arr', res.meta.round_ids_arr)
      } else {
        this.$Message.error(res.message)
      }
    },
    hadleTimeSlider(arr) {
      if (this.user_key) {
        if (!this.is_vip) {
          this.handleShowVipPormpt()
          this.years = [this.params.s_time, this.params.e_time]
        } else {
          this.years = [Math.round(arr[0]), Math.round(arr[1])]
          if (this.params.s_time != Math.round(arr[0]) || this.params.e_time != Math.round(arr[1])) {
            this.params.s_time = Math.round(arr[0])
            this.params.e_time = Math.round(arr[1])
            this.list_params.s_time = Math.round(arr[0])
            this.list_params.e_time = Math.round(arr[1])
            this.list_params.page = 1
            this.getMap()
            this.getList()
          }
        }
      } else {
        this.years = [this.params.s_time, this.params.e_time]
        this.login()
      }
    },
    addressChecked(val) {
      this.params.demostic = val.demostic
      this.params.address_id = val.address_id
      this.list_params.demostic = val.demostic
      this.list_params.address_id = val.address_id
      this.list_params.page = 1
      this.getMap()
      this.getList()
    },
    goEntityDetail(uid, type) {
      _czc.push(['_trackEvent', '投融资页面', '投融资事件' + '_' + this.page_title + '下载点击'])
      if (type == 2) {
        // this.$router.push({name: 'PeoDetail', params: {uid: uid}})
        const {
          href
        } = this.$router.resolve({
          name: "PeoDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if (type == 1) {
        // this.$router.replace({name: 'OrgDetail', params: {uid: uid}})
        const {
          href
        } = this.$router.resolve({
          name: "OrgDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else {
        // this.$router.push({name: 'CompanyDetail', params: {uid: uid}})
        const {
          href
        } = this.$router.resolve({
          name: "CompanyDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      }
    },
    downloadEcharts() { // 打开下载模态框(imgbase,筛选条件，题目)
      _czc.push(['_trackEvent', '投融资页面', this.page_title + '_' + this.name + '下载点击'])
      this.loginVipFlow(() => {
        this.imgbase = this.mychart.getDataURL({
          pixelRatio: 1,
          backgroundColor: !this.theme_switch ? '#2A2F42' : '#ffffff'
        })
        this.visible = true
        // console.log(this.imgbase)
      })
    },
    haddleChangeYQ(val) {
      if (val == '1') {
        _czc.push(['_trackEvent', '投融资页面', this.page_title + '_' + this.name + '年度点击'])
      } else {
        _czc.push(['_trackEvent', '投融资页面', this.page_title + '_' + this.name + '季度点击'])
      }
      this.loginVipFlow(() => {
        this.params.count_type = val
        this.getMap()
      })
    },
    haddleChangeYQ1(val) {
      if (val == '1') {
        _czc.push(['_trackEvent', '投融资页面', this.page_title + '_' + this.name + '年度点击'])
      } else {
        _czc.push(['_trackEvent', '投融资页面', this.page_title + '_' + this.name + '季度点击'])
      }
      this.loginVipFlow(() => {
        this.params.count_type = val
        this.getMap()
      })
    },
    closeEcharts() { // 关闭下载模态框
      this.visible = false
    },
    sliderTipFormat(val) {
      return Math.round(val)
    },
    /*
     * 翻页
     * anthor: wang.y
     */
    handleChangePage(val) {
      if (this.user_key) {
        if (!this.is_vip) {
          this.handleShowVipPormpt()
          this.$refs['pages'].currentPage = parseInt(this.params.page)
        } else {
          this.list_params.page = val
          this.getList()
        }
      } else {
        this.$refs['pages'].currentPage = parseInt(this.params.page)
        this.login()
      }
    },
    haddleClickChart1(params) {
      if (this.curInt !== params.dataIndex) {
        this.curInt = params.dataIndex
        this.list_params.s_time = params.name
        this.list_params.e_time = params.name
      } else {
        this.curInt = ''
        this.list_params.s_time = this.years[0]
        this.list_params.e_time = this.years[1]
      }
      this.list_params.page = 1
      this.getList()
    },
    getyearColor() {
      this.year_option.series[0].itemStyle.normal.color = (params) => {
        return params.dataIndex !== this.curInt ? '#2F54EB' : '#233EB0'
      }
      this.year_option.series[1].itemStyle.normal.color = (params) => {
        return params.dataIndex !== this.curInt ? '#40A9FF' : '#2F7EBF'
      }
      this.year_option.series[2].itemStyle.normal.color = (params) => {
        return params.dataIndex !== this.curInt ? '#80DEEA' : '#5FA6AF'
      }
      this.year_option.series[3].itemStyle.normal.color = (params) => {
        return params.dataIndex !== this.curInt ? '#1EA69C' : '#167C74'
      }
      this.year_option.series[4].symbolSize = (item, params) => {
        return params.dataIndex !== this.curInt ? 4 : 8
      }
    },
    /*
     * 投融资总趋势（融资额、平均融资额、融资事件）皮肤切换
     * anthor: wang.y
     */
    echartChangeTheme1() {
      const _this = this
      if (this.params.count_type == '1') {
        this.year_option.legend.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#666666'
        this.year_option.xAxis[0].axisPointer.lineStyle.color = !this.theme_switch ? 'rgba(255,255,255,0.30)' : '#CCCCCC'
        this.year_option.xAxis[0].axisLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
        this.year_option.xAxis[0].axisLabel.textStyle.color = function(item, index) {
          if (_this.theme_switch) {
            return index !== _this.curInt ? '#BCBDC1' : '#333333'
          } else {
            return index !== _this.curInt ? '#BBBBBB' : '#ffffff'
          }
        }
        // this.year_option.series[5].label.normal.color = !this.theme_switch ? '#BCBDC1' : '#999999'
        this.year_option.yAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
        this.year_option.yAxis[1].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
        this.year_option.yAxis[0].splitLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
        this.year_option.graphic.style.image = !this.theme_switch ? require('../pic/watermark-white3.png') : require('../pic/watermark-gray3.png')
      } else {
        this.quarter_option.legend.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#666666'
        this.quarter_option.xAxis[0].axisPointer.lineStyle.color = !this.theme_switch ? 'rgba(255,255,255,0.30)' : '#CCCCCC'
        this.quarter_option.xAxis[0].axisLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
        this.quarter_option.xAxis[1].axisTick.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
        this.quarter_option.xAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#797B83' : '#999999'
        this.quarter_option.xAxis[1].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
        this.quarter_option.yAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
        this.quarter_option.yAxis[1].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
        this.quarter_option.yAxis[0].splitLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
        this.quarter_option.graphic.style.image = !this.theme_switch ? require('../pic/watermark-white3.png') : require('../pic/watermark-gray3.png')
      }
    },
    /*
     * 投融资总趋势（领域分布、地域分布-全球）皮肤切换
     * anthor: wang.y
     */
    echartChangeTheme2() {
      const _this = this
      this.option.legend.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#666666'
      this.option.graphic.style.image = !this.theme_switch ? require('../pic/watermark-white3.png') : require('../pic/watermark-gray3.png')
      this.option.xAxis[0].axisPointer.lineStyle.color = !this.theme_switch ? 'rgba(255,255,255,0.30)' : '#CCCCCC'
      this.option.xAxis[0].axisLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
      // this.option.xAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
      this.option.xAxis[0].axisLabel.textStyle.color = function(item, index) {
        if (_this.theme_switch) {
          return index !== _this.curInt ? '#BCBDC1' : '#333333'
        } else {
          return index !== _this.curInt ? '#BBBBBB' : '#ffffff'
        }
      }
      this.option.yAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
      this.option.yAxis[0].splitLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
      this.option.yAxis[1].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
    },
    /*
     * 投融资总趋势（地域分布）皮肤切换
     * anthor: wang.y
     */
    echartChangeTheme3() {
      const _this = this
      this.option.legend.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#666666'
      this.option.graphic.style.image = !this.theme_switch ? require('../pic/watermark-white3.png') : require('../pic/watermark-gray3.png')
      this.option.xAxis[0].axisPointer.lineStyle.color = !this.theme_switch ? 'rgba(255,255,255,0.30)' : '#CCCCCC'
      this.option.xAxis[0].axisLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
      // this.option.xAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
      this.option.xAxis[0].axisLabel.textStyle.color = function(item, index) {
        if (_this.theme_switch) {
          return index !== _this.curInt ? '#BCBDC1' : '#333333'
        } else {
          return index !== _this.curInt ? '#BBBBBB' : '#ffffff'
        }
      }
      this.option.yAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
      this.option.yAxis[0].splitLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
      this.option.yAxis[1].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
      this.a_option.graphic.style.image = !this.theme_switch ? require('../pic/watermark-white3.png') : require('../pic/watermark-gray3.png')
      this.even_option.graphic.style.image = !this.theme_switch ? require('../pic/watermark-white3.png') : require('../pic/watermark-gray3.png')
      this.map_option.graphic.style.image = !this.theme_switch ? require('../pic/watermark-white3.png') : require('../pic/watermark-gray3.png')
      this.a_option.legend.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#666666'
      this.even_option.legend.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#666666'
    },
    /*
     * 当前热点领域（融资事件、融资额）皮肤切换
     * anthor: wang.y
     */
    echartChangeTheme4() {
      const _this = this
      this.option.legend.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#666666'
      this.option.xAxis[0].axisPointer.lineStyle.color = !this.theme_switch ? 'rgba(255,255,255,0.30)' : '#CCCCCC'
      this.option.xAxis[0].axisLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
      this.option.xAxis[1].axisTick.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
      if (this.params.count_type == 1) {
        this.option.xAxis[0].axisLabel.textStyle.color = function(item, index) {
          if (_this.theme_switch) {
            return index !== _this.curInt ? '#BCBDC1' : '#333333'
          } else {
            return index !== _this.curInt ? '#BBBBBB' : '#ffffff'
          }
        }
      } else {
        this.option.xAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#797B83' : '#999999'
      }
      this.option.xAxis[1].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
      this.option.yAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
      this.option.yAxis[1].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
      this.option.yAxis[0].splitLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
      this.option.graphic.style.image = !this.theme_switch ? require('../pic/watermark-white3.png') : require('../pic/watermark-gray3.png')
    },
    /*
     * 投融资总趋势（轮次分布）皮肤切换
     * anthor: wang.y
     */
    echartChangeTheme5() {
      const _this = this
      this.option.legend.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#666666'
      this.option.xAxis[0].axisPointer.lineStyle.color = !this.theme_switch ? 'rgba(255,255,255,0.30)' : '#CCCCCC'
      if (this.params.count_type == 1) {
        this.option.xAxis[0].axisLabel.textStyle.color = function(item, index) {
          if (_this.theme_switch) {
            return index !== _this.curInt ? '#BCBDC1' : '#333333'
          } else {
            return index !== _this.curInt ? '#BBBBBB' : '#ffffff'
          }
        }
      } else {
        this.option.xAxis[1].axisTick.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
        this.option.xAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#797B83' : '#999999'
        this.option.xAxis[1].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
      }
      this.option.xAxis[2].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#999999'
      this.option.xAxis[0].axisLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'

      this.option.yAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
      this.option.yAxis[0].splitLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'

      this.option.graphic.style.image = !this.theme_switch ? require('../pic/watermark-white3.png') : require('../pic/watermark-gray3.png')
    },
    /*
     * 当前热点领域多领域皮肤切换
     * anthor: wang.y
     */
    echartChangeTheme6() {
      const _this = this
      this.arr_option.legend.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#666666'
      this.arr_option.xAxis[0].axisPointer.lineStyle.color = !this.theme_switch ? 'rgba(255,255,255,0.30)' : '#CCCCCC'
      this.arr_option.xAxis[0].axisLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
      this.arr_option.xAxis[1].axisTick.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
      if (this.params.count_type == 1) {
        this.arr_option.xAxis[0].axisLabel.textStyle.color = function(item, index) {
          if (_this.theme_switch) {
            return index !== _this.curInt ? '#BCBDC1' : '#333333'
          } else {
            return index !== _this.curInt ? '#BBBBBB' : '#ffffff'
          }
        }
      } else {
        this.arr_option.xAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#797B83' : '#999999'
      }
      this.arr_option.xAxis[1].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
      this.arr_option.yAxis[0].axisLabel.textStyle.color = !this.theme_switch ? '#BCBDC1' : '#BBBBBB'
      this.arr_option.yAxis[0].splitLine.lineStyle.color = !this.theme_switch ? '#40444F' : '#E9E9E9'
      this.arr_option.graphic.style.image = !this.theme_switch ? require('../pic/watermark-white3.png') : require('../pic/watermark-gray3.png')
    },
    handleChangeUnit(val) {
      this.loginVipFlow(() => {
        this.params.unit_type = val
        this.getMap()
      })
    },
    pageCancel(value) {
      this.page_modal = value
    },
    /**
     * 列表排序功能
     */
    haddleChangeSort(val) {
      this.loginVipFlow(() => {
        if(this.sort_id != val) {
          this.sort_id = val
          this.list_params.sort_type = val
          this.list_params.page = 1
          this.getList()
        }
      })
    }
  },
  mounted() {
    this.is_destroyed = false
  },
  destroyed() {
    this.is_destroyed = true
  }
}

export {
  financing_common
}
